<template>
  <div class="footer">
<!--    <div class="icp">{{`© 地址： ${address} 联系电话： ${tel} 邮箱： ${Email}` }}</div>-->
    <div class="icp">{{`© 地址： ${address} 联系电话： ${tel}` }}</div>
    <div class="icp">{{`© ${year} ${author} ` }}<a href="http://beian.miit.gov.cn/" target="_blank">{{ record }}</a></div>
  </div>
</template>

<script setup>
let address = '上海市';    //地址
let tel = '021-31021022';       //电话
// let Email = 'lab@biozeron.com';          //邮箱
let year = new Date().getFullYear();        // 一般都是最新的一年
let author = '上海凌恩';					// 作者名
let record = '沪ICP备20010476号-2.';			// 备案号
</script>

<style>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  padding: 10px 0;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
}
.icp {
  margin: 5px 0;
  color: black;

}
.icp > a {
  color: #ced5d5;
  text-decoration: none;
}
.icp > a:hover {
  color: #bae7ff;
  text-decoration: none;
}
</style>
